import { render, staticRenderFns } from "./FaseCultivo.vue?vue&type=template&id=9d467570"
import script from "./FaseCultivo.vue?vue&type=script&lang=js"
export * from "./FaseCultivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports